import { render, staticRenderFns } from "./CourseImgsTemp.vue?vue&type=template&id=41ec8723&scoped=true&"
import script from "./CourseImgsTemp.vue?vue&type=script&lang=js&"
export * from "./CourseImgsTemp.vue?vue&type=script&lang=js&"
import style0 from "./CourseImgsTemp.vue?vue&type=style&index=0&id=41ec8723&scoped=scoped&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41ec8723",
  null
  
)

export default component.exports